<template lang="pug">
CommentModal(
  v-if="routeNid"
  :nid="nid"
  :language="commentLanguage"
)
</template>

<script setup lang="ts">
import { provide } from "vue";
import { useRouter } from "vue-router";
import { InModalViewKey } from "~/injectionKeys";

provide(InModalViewKey, true);

const i18n = useI18n();
const locale = i18n.locale;

const { currentRoute } = useRouter();

const routeNid = computed<string>(
  () => currentRoute.value.params?.nid?.toString() ?? "",
);
const nid = computed<number>(() => parseInt(routeNid.value) || NaN);
const commentLanguage = computed<string>(
  () => currentRoute.value.query?.language?.toString() || locale.value,
);
</script>
